<div class="one-avatar">

  <div class="avatar">

    <ngx-avatar src="{{avatarUrl}}" size="{{this.size}}" *ngIf="size != null"></ngx-avatar>
    <ngx-avatar src="{{avatarUrl}}" *ngIf="size == null"></ngx-avatar>

  </div>

</div>
